import { FC, useCallback } from "react";
import { TaskListExtension } from "@remirror/extension-list";
import { useActive, useCommands } from "@remirror/react";
import { CommandButton, CommandButtonProps } from "@remirror/react-ui";

export interface ToggleTaskListButtonProps
  extends Omit<
    CommandButtonProps,
    "commandName" | "active" | "enabled" | "attrs" | "onSelect"
  > {
  onBlur: () => void;
}

export const ToggleTaskListButton: FC<ToggleTaskListButtonProps> = (props) => {
  const { toggleTaskList } = useCommands<TaskListExtension>();

  const handleSelect = useCallback(() => {
    if (toggleTaskList.enabled()) {
      toggleTaskList();
      props.onBlur();
    }
  }, [props, toggleTaskList]);

  const active = useActive<TaskListExtension>().taskList();
  const enabled = toggleTaskList.enabled();

  return (
    <CommandButton
      {...props}
      commandName="toggleTaskList"
      active={active}
      enabled={enabled}
      onSelect={handleSelect}
    />
  );
};
